import React from 'react';

import { ProgressCircle } from "./ProgressRing.styles";










export const ProgressRing = ({
  diameter,
  stroke,
  progress,
  color,
  className,
  animationDuration }) =>
{
  const radius = diameter / 2;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - progress / 100 * circumference;

  return /*#__PURE__*/(
    React.createElement("svg", {

      className: className,
      height: diameter,
      width: diameter,
      viewBox: `0 0 ${diameter} ${diameter}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

    React.createElement(ProgressCircle, {
      stroke: color,
      fill: "transparent",
      strokeWidth: stroke,
      strokeDasharray: `${circumference} ${circumference}`,
      style: { strokeDashoffset },
      r: normalizedRadius,
      cx: radius,
      cy: radius,
      animationDuration: animationDuration })));



};